var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-tooltip",class:_vm.tooltip.position || '',style:({ left: _vm.left + 'px', top: _vm.top + 'px' }),domProps:{"innerHTML":_vm._s(_vm.tooltip.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }